import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_silky_red/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-7065c973cf.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-4e5297556a.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-f04f8dad87.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-6de4f009ea.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-582f0f05e3.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-b549acc650.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-ff9e23a3e2.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-3c30e12e0c.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-42bbcca696.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-ec66602208.png'; };
